<template>
  <div class="flow-list">
    <div class="list-tit">
      <div class="box-content">
        <p>{{ titleContent }}</p>
        <el-tag type="info" v-if="flowKey === 'film' && flowData.category">
          {{flowData.category}}
        </el-tag>
      </div>
      <el-checkbox v-if="!isForNewAdd" v-model="isChecked" class="show-time-checkbox" @change="(val) => selectGroupHandler(val, flowKey, flowData[typeMapping[flowKey]])"></el-checkbox>
    </div>

    <div class="list-items">
      <div
        class="box box-item"
        :class="schedule.approve ? 'approve' : ''"
        v-for="schedule in flowData.items"
        :key="schedule.scheduleId"
      >
        <div class="box-content">
          <el-popover width="400" popper-class="schedule-popover" trigger="hover">
            <div :class="schedule.approve ? 'popover-box approve' : 'popover-box'">
              <div class="ta-r" v-if="flowKey !== 'film' || showHandle && flowKey === 'film'">
                <el-button
                  v-if="flowKey === 'film'"
                  type="text"
                  @click="() => $emit('showSoldSeatFn', schedule.scheduleId, flowData.filmId)"
                ><i class="operation-icon"></i></el-button>
                <el-button type="text" @click="openUrlFn(schedule.onlineBookingUrl)">
                <i class="el-icon-link"></i>
                </el-button>
                <el-button type="text" @click="editScheduleFn(schedule.scheduleId)">
                  <i class="el-icon-edit-outline"></i>
                </el-button>
                <el-button type="text" @click="delScheduleFn(schedule.scheduleId)">
                  <i class="el-icon-delete"></i>
                </el-button>
              </div>
              <div class="box">
                <h2 class="movie-name">
                  {{ flowKey === "film" ? flowData.filmName : schedule.filmName }}
                </h2>
                <el-tag :type="schedule.approve ? 'warning' : 'info'" v-if="flowData.category">
                  {{flowData.category}}
                </el-tag>
                <el-tag :type="schedule.approve ? 'warning' : 'info'" v-if="schedule.versionName">
                  {{schedule.versionName}}
                </el-tag>
                <el-tag :type="schedule.approve ? 'warning' : 'info'" v-if="schedule.subtitlesVersionName">
                  {{schedule.subtitlesVersionName}}
                </el-tag>
                <template v-if="schedule.otherVersionName && schedule.otherVersionName.length > 0">
                  <el-tag :type="schedule.approve ? 'warning' : 'info'"
                    v-for="id in schedule.otherVersionName"
                    :key="id"
                  >
                    {{ (otherVersionList.find(item => item.id === id) || {}).name }}
                  </el-tag>
                </template>
                <el-tag :type="schedule.approve ? 'warning' : 'info'" v-if="schedule.mvtkCode">
                  {{schedule.mvtkCode}}
                </el-tag>
              </div>
              <div class="box">
                <p class="show-time">
                  {{ $moment(schedule.startTime).format("HH:mm") }} -
                  {{ $moment(schedule.endTime).format("HH:mm") }}
                </p>
                <span v-if="flowKey === 'subtitles'">{{ flowData.houseName }}</span>
              </div>
              <div class="box" v-if="!flowData.reflect">
                <p>{{ `${$locale('schedule.reflectionTime')}: ${$moment(schedule.reflectDate).format('YYYY-MM-DD')}(${weekLocaleArray[$moment(schedule.reflectDate).day()]})` }}</p>
              </div>
            </div>
            <div slot="reference" style="position:relative;">
              <span v-if="schedule.freeSeat" class="freeSeat-icon"></span>
              <p class="show-time">
                {{ $moment(schedule.startTime).format("HH:mm") }} -
                {{ $moment(schedule.endTime).format("HH:mm") }}
              </p>
              <p class="movie-name" v-if="flowKey !== 'film'">{{ schedule.filmName }}</p>
              <p>
                <el-tag :type="schedule.approve ? 'warning' : 'info'" v-if="schedule.versionName">
                  {{ schedule.versionName }}
                </el-tag>
                <el-tag :type="schedule.approve ? 'warning' : 'info'" v-if="schedule.subtitlesVersionName">
                  {{ schedule.subtitlesVersionName }}
                </el-tag>
                <template v-if="schedule.otherVersionName && schedule.otherVersionName.length > 0">
                  <el-tag :type="schedule.approve ? 'warning' : 'info'"
                    v-for="otherVersionId in schedule.otherVersionName"
                    :key="otherVersionId"
                  >
                    {{ (otherVersionList.find(item => item.id === otherVersionId)||{}).name }}
                  </el-tag>
                </template>
              </p>
              <p v-if="flowKey !== 'screen'">
                <el-tag :type="schedule.approve ? 'warning' : 'info'" v-if="schedule.houseName">
                  {{ schedule.houseName }}
                </el-tag>
                <span class="ruleName">
                  <img src="@/assets/img/ruleTemplate.svg" />
                  <span>{{schedule.ticketRuleName}}</span>
                </span>
              </p>
            </div>
          </el-popover>
          <el-checkbox v-if="!isForNewAdd" :value.sync="schedule.isChecked" class="show-time-checkbox" @change="(val) => selectHandler(val, schedule.scheduleId)"></el-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deleteSchedule } from "@/helpers/service/api/schedule.js";
import countDownAlert from "@/utils/countDownAlert";
import { weekLocaleArray, weekSelectArray } from "@/utils/common";


export default {
  inject: ["setSelected", "setGroupSelected"],
  name: "FlowListItem",
  props: {
    flowKey: {
      required: true,
      type: String,
    },
    flowData: {
      required: true,
      type: Object,
    },
    showHandle: {
      type: Boolean,
      default: null,
    },
    otherVersionList: {
      type: Array,
      default: () => []
    },
    isForNewAdd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: false,
      weekLocaleArray,
      typeMapping: {
        film: "filmId",
        screen: "houseName",
        subtitles: "versionName"
      }
    };
  },
  computed: {
    titleContent() {
      let _result = "";
      const {
        filmName,
        houseName,
        versionName,
      } = this.flowData;

      switch(this.flowKey) {
      case "film":
        _result = filmName;
        break;
      case "screen":
        _result = houseName || versionName;
        break;
      case "subtitles":
        _result = versionName;
        break;
      default:
        break;
      }

      return _result;
    }
  },
  methods: {
    openUrlFn(url) {
      window.open(url);
    },
    editScheduleFn(id) {
      const path = "/schedule/edit/" + id;
      this.$router.push({ path });
    },
    delScheduleFn(id) {
      const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("movie.deleteSchedule")}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        deleteSchedule({ id }).then(res => {
          if (res.success) {
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                this.$emit("delScheduleCallBack", id);
              }
            });
          } else {
            this.$alert(res.message, {
              showClose: false,
            });
          }
        });
      });
    },
    selectGroupHandler(val, type, id) {
      this.setGroupSelected(val, type, id)
    },
    selectHandler(val, id) {
      this.setSelected(val, id)
    }
  },
  watch: {
    flowData: {
      handler(newVal, oldVal) {
        this.isChecked = (newVal.items.length === newVal.items.filter(item => item.isChecked).length)
      },
      deep: true
    }
  }
};
</script>
